import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddUserForm from "./AddUserForm";
import AddUserFormForProposals from "./AddUserFormForProposals";

class AddUserModal extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }

  handleSubmit = () => {

    if (this.formRef.current && typeof this.formRef.current.handleSubmit === 'function') {
      this.formRef.current.handleSubmit();
    } else {
      console.error('Form ref or handleSubmit is not correctly set');
    }
  };

  handleConfirm = () => {
    this.handleSubmit();
  };
  render() {
    const { isOpen, onConfirm, onCancel, proposalEditor = false, agency } = this.props;

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>Add New User</ModalHeader>
        <ModalBody>
          {!proposalEditor ? (
            <AddUserForm  
            ref={this.formRef}
            onConfirm={onConfirm}
            />
          ) : (
            <AddUserFormForProposals agency={agency} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button outline onClick={onCancel}>Cancel</Button>{' '}
          <Button color="primary" onClick={this.handleConfirm}>Add User</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddUserModal;
